import { z } from "zod";
// Mirrors the browser tracker's QueuedEvent shape
// (packages/analytics/src/track.ts) rather than importing it — the
// collector validates event_name/properties against the typed catalog
// itself, so this is a transport-shape check, not a catalog re-export.
export const EVENT_BATCH_MAX_SIZE = 50;
export const trackedEventSchema = z.object({
    event_name: z.string().min(1),
    occurred_at: z.string().datetime(),
    properties: z.record(z.unknown()),
    session_id: z.string().optional(),
    anonymous_id: z.string().optional(),
    context: z.record(z.unknown()).optional(),
});
export const eventBatchSchema = z.array(trackedEventSchema).min(1).max(EVENT_BATCH_MAX_SIZE);
